/**
 * UI 層 form 映射／空列／送出前正規化。
 * HTTP serialize 仍由 api create／update 內建 buildProcessingFactoryWritePayload 處理。
 */

export function mapProcessingFactoryDetailToForm(detail) {
  return {
    code: detail?.code ?? '',
    name: detail?.name ?? '',
    chineseName: detail?.chineseName ?? '',
    englishName: detail?.englishName ?? '',
    taxIdNumber: detail?.taxIdNumber ?? '',
    homepage: detail?.homepage ?? '',
    phone: detail?.phone ?? '',
    fax: detail?.fax ?? '',
    remark: detail?.remark ?? '',
    warehouseIds: Array.isArray(detail?.warehouseIds)
      ? detail.warehouseIds.map(String)
      : [],
    addresses: (detail?.addresses ?? []).map(mapAddressToForm),
    contacts: (detail?.contacts ?? []).map(mapContactToForm),
  };
}

export function createEmptyAddressRow() {
  return {
    addressType: '',
    postalCode: '',
    city: '',
    district: '',
    address: '',
    isDefault: false,
    remark: '',
  };
}

export function createEmptyContactRow() {
  return {
    name: '',
    department: '',
    title: '',
    phone: '',
    mobile: '',
    email: '',
    isDefault: false,
    remark: '',
  };
}

/**
 * 送出前：編 lineNo（10、20…）；同陣列 isDefault 僅保留第一筆 true。
 * create／update API 會再跑 serialize。
 */
export function prepareProcessingFactoryFormValues(values) {
  return {
    ...values,
    warehouseIds: (values?.warehouseIds ?? []).map(String),
    addresses: normalizeRowsWithLineNo(values?.addresses),
    contacts: normalizeRowsWithLineNo(values?.contacts),
  };
}

function normalizeRowsWithLineNo(rows) {
  let defaultSeen = false;
  return (rows ?? []).map((row, index) => {
    const wantsDefault = Boolean(row?.isDefault);
    const isDefault = wantsDefault && !defaultSeen;
    if (isDefault) {
      defaultSeen = true;
    }
    return {
      ...row,
      lineNo: (index + 1) * 10,
      isDefault,
    };
  });
}

function mapAddressToForm(row) {
  return {
    addressType: row?.addressType ?? '',
    postalCode: row?.postalCode ?? '',
    city: row?.city ?? '',
    district: row?.district ?? '',
    address: row?.address ?? '',
    isDefault: Boolean(row?.isDefault),
    remark: row?.remark ?? '',
  };
}

function mapContactToForm(row) {
  return {
    name: row?.name ?? '',
    department: row?.department ?? '',
    title: row?.title ?? '',
    phone: row?.phone ?? '',
    mobile: row?.mobile ?? '',
    email: row?.email ?? '',
    isDefault: Boolean(row?.isDefault),
    remark: row?.remark ?? '',
  };
}
